<template>
  <v-container fluid class="pa-4 main-bg">
    <!-- FILTER PANEL -->
  <v-col cols="12" sm="10" md="8" lg="6">
        <v-card class="elevated-card" dark>
          <v-card-title class="headline font-weight-bold justify-center">
            <div class="text-center">
              <div class="text-h5">Izlash</div>
            </div>
          </v-card-title>

          <!-- <v-divider></v-divider> -->
          <v-card-text>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-row dense>
                    <v-col cols="12" sm="4">
                      <v-select hide-details dense outlined
                      v-model="form.gender"
                      :items="genders"
                      item-text="name"
                      item-value="id" label="Jinsi" ></v-select>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-select v-model="form.nationality"
                      :items="nationalities"
                      item-text="name"
                      item-value="id"
                      label="Millati" hide-details dense outlined ></v-select>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-select 
                      v-model="form.region"
                      :items="regions"
                      item-text="name"
                      item-value="id"
                      label="Viloyat" hide-details dense outlined></v-select>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field hide-details dense outlined
                      v-model="form.min_age" label="Minimum"  type="number"></v-text-field>

                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field hide-details dense outlined
                      v-model="form.max_age" label="Maksimum" type="number"></v-text-field>

                    </v-col>
                    <v-btn
                          color="primary"
                          large
                          class="elevated-btn"
                        @click="submit"
                        >
                          Izlash
                        </v-btn>
                  </v-row>
                </v-form>
              </v-card-text>
                    </v-card>
      </v-col>


    <!-- CANDIDATE CARDS -->
    <v-row dense>
      <v-col
        v-for="candidate in candidates"
        :key="candidate.id"
        cols="12"
        sm="6"
        md="4"
        lg="3"
      >
        <v-card
          class="pa-5"
          max-width="380"
          elevation="4"
          style="border-radius: 20px;"
        >

          <v-row no-gutters>
            <!-- Avatar -->
            <v-col cols="3" class="d-flex justify-center">
              <v-avatar size="70" tile>
                <v-img
                  :src="candidate.gender=='A' ? require('@/assets/girl.jpg') : require('@/assets/boy2.jpeg')"
                  class="elevation-2"
                  style="background-color: #A259FF; border-radius: 20px;"
                ></v-img>
              </v-avatar>
            </v-col>

            <!-- Info -->
            <v-col cols="9" class="pl-4">
              <h3 :style="{ color: candidate.gender == 'A' ? 'orange' : 'purple' }" class="font-weight-bold mb-1">{{ candidate.gender == 'A' ? 'Kelin' : 'Kuyov' }}</h3>
              <p style="font-size:14px" class="grey--text mb-0">{{candidate.marital_status.name}}</p>
              <p style="font-size:14px" class="grey--text mb-0">{{candidate.profession}}</p>
            </v-col>
          </v-row>

          <!-- Stats & Button -->
          <v-row class="mt-2" align="center">
            <v-col cols="4" class="text-center">
              <v-icon color="purple">mdi-cake-variant-outline</v-icon>
              <h6 class="mb-0 font-weight-bold"> {{ candidate.age }} </h6>
            </v-col>

            <v-col cols="4" class="text-center">
              <v-icon color="purple">mdi-human-male-height</v-icon>
              <h6 class="mb-0 font-weight-bold"> {{ candidate.height }} </h6>
            </v-col>
            
            <v-col cols="4" class="text-center">
              <v-icon color="purple">mdi-weight-kilogram</v-icon>
              <h6 class="mb-0 font-weight-bold">{{ candidate.weight }}</h6>
              
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "Candidates",
  data() {
    return {
      defaultPhoto: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
      candidates: [],
      genders: [
        { id: "E", name: "Kuyov" },
        { id: "A", name: "Kelin" },
      ],
      nationalities: [],
      regions: [],
      form: {
        min_age: "",
        max_age: "",
        gender: "E",
        region: "",
        nationality: "",
      },
    };
  },
  methods: {
    async search() {
      this.loading = true;
      try {
        const res = await axios.post(
          this.$store.state.backend_url + "api/get-candidates-search",
          { filter: this.form }
        );
        this.candidates = res.data;
        // this.resetForm();/
      } catch (error) {
        alert("Xatolik: " + error.message);
      } finally {
        this.loading = false;
      }
    },
    async getRef() {
      try {
        const res = await axios.get(
          this.$store.state.backend_url + "api/get-profile-datas"
        );
        this.educations = res.data.educations;
        this.nationalities = res.data.nationalities;
        this.regions = res.data.regions;
      } catch (error) {
        console.error(error);
      }
    },
    getAlert() {
      alert("test");
    },
    resetForm() {
      this.form = {
        min_age: "",
        max_age: "",
        nationality: "",
        gender: "",
        region: "",
      };
    },
  },
  mounted() {
    this.getRef();
  },
};
</script>

<style scoped>
/* Background */
.main-bg {
  min-height: 100vh;
}

/* Filter Card */
.filter-card {
  background-color: #1E1E1E;
  backdrop-filter: blur(10px);
  color: #fff !important;
  border: 1px solid rgba(255, 255, 255, 0.15);
}

/* Input & Select Texts */
.field-white {
  color: #fff !important;
}

.field-white .v-label {
  color: rgba(255, 255, 255, 0.85) !important;
  font-weight: 500;
}

.field-white input {
  color: #fff !important;
}

.field-white .v-field__outline {
  border-color: rgba(255, 255, 255, 0.25) !important;
}

.field-white .v-field__outline:hover {
  border-color: rgba(255, 255, 255, 0.45) !important;
}

/* Candidate Card */
.candidate-card {
  background-color: #1E1E1E;
  backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: 0.3s ease;
}
.candidate-card:hover {
  transform: scale(1.03);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
}

/* Region label */
.region-label {
  font-size: 1rem;
  font-weight: 600;
  color: #fff;
}

/* Info boxes */
.info-badges {
  gap: 8px;
}
.info-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: rgba(255, 255, 255, 0.06);
  padding: 8px 12px;
  border-radius: 12px;
  min-width: 70px;
  color: #fff;
  font-size: 0.85rem;
}
.custom-select {
  font-size: 12px !important;           /* Umumiy matnni kichraytiradi */
  min-height: 12px !important;          /* Select balandligini kamaytiradi */
}

/* Select ichidagi input */
.custom-select .v-input__control {
  min-height: 12px !important;          /* Ichki balandlikni kamaytiradi */
  padding: 0 !important;
}

/* Label (placeholder) uchun */
.custom-select .v-label {
  font-size: 12px !important;
  top: 4px !important;
}

/* Tanlangan qiymat uchun */
.custom-select .v-select__selections {
  font-size: 12px !important;
  min-height: 12px !important;
  padding-top: 0 !important;
}

/* Select ichidagi ikonka uchun */
.custom-select .v-input__append-inner {
  height: 12px !important;
  margin-top: -2px;
}
</style>
